import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Application } from '../models/application';
import { RootState } from '../store';

const initialState: Application = {
  colorMode: 'system',
  privacyTerm: false,
  uploadTerm: false,
  showPushDialog: false,
  backgroundChecksPrivacyTerm: false,
  scrollY: 0,
  custom_prompts: [],
};

const setup = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setColorMode(state, { payload }: PayloadAction<Application['colorMode']>) {
      return { ...state, colorMode: payload };
    },
    setPrivacyTerm(state, { payload }: PayloadAction<boolean>) {
      return { ...state, privacyTerm: payload };
    },
    setUploadTerm(state, { payload }: PayloadAction<boolean>) {
      return { ...state, uploadTerm: payload };
    },

    setShowPushDilog(state, { payload }: PayloadAction<boolean>) {
      return { ...state, showPushDialog: payload };
    },
    setBackgroundChecksPrivacyTerm(state, { payload }: PayloadAction<boolean>) {
      return { ...state, backgroundChecksPrivacyTerm: payload };
    },
    setScrollY(state, { payload }: PayloadAction<number>) {
      return { ...state, scrollY: payload };
    },
    setCustomPrompts(
      state,
      { payload }: PayloadAction<Application['custom_prompts']>
    ) {
      return { ...state, custom_prompts: payload };
    },
    clearApplication() {
      return initialState;
    },
  },
});

export const {
  setColorMode,
  setPrivacyTerm,
  setUploadTerm,
  setShowPushDilog,
  setBackgroundChecksPrivacyTerm,
  setScrollY,
  setCustomPrompts,
  clearApplication,
} = setup.actions;

export const selectColorMode = ({ application }: RootState) =>
  application.colorMode;
export const selectPrivacyTerm = ({ application }: RootState) =>
  application.privacyTerm;
export const selectUploadTerm = ({ application }: RootState) =>
  application.uploadTerm;
export const selectShowPushDialog = ({ application }: RootState) =>
  application.showPushDialog;
export const selectBackgroundChecksPrivacyTerm = ({ application }: RootState) =>
  application.backgroundChecksPrivacyTerm;
export const selectScrollY = ({ application }: RootState) =>
  application.scrollY;
export const selectCustomPrompts = ({ application }: RootState) =>
  application.custom_prompts;

export default setup.reducer;
